import { useApplicationToast } from "../webcontent/ApplicationToastProvider";
import { useEffect } from "react";
import { useReportAmendment } from "../api/ReportsApi";
import {
  ExclamationTriangleIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/outline";

export const useAmendReportWithToast = () => {
  const { showLargeToast } = useApplicationToast();

  const {
    isLoading: loadingAmendment,
    mutate: openAmendment,
    error: errorAmendment,
    isSuccess: isSuccessAmendment,
  } = useReportAmendment();

  useEffect(() => {
    if (errorAmendment) {
      showLargeToast?.({
        title: "Error!",
        message:
          "Couldn't open the amendment please try again later or contact support.",
        icon: (
          <div className="bg-red-100 text-red-600 rounded-full p-2">
            <ExclamationTriangleIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [errorAmendment, showLargeToast]);

  useEffect(() => {
    if (isSuccessAmendment) {
      showLargeToast?.({
        title: "Open Amendment",
        message:
          "Are you sure you want to open an amendment? Any changes made will overwrite the original report and cannot be undone.",
        icon: (
          <div className="bg-green-100 text-green-600 rounded-full p-2">
            <ShieldExclamationIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [isSuccessAmendment, showLargeToast]);

  return { openAmendment, loadingAmendment, errorAmendment };
};
